
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/thermostat/order/[product]",
      function () {
        return require("private-next-pages/services/thermostat/order/[product].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/thermostat/order/[product]"])
      });
    }
  